
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/accordion",
      function () {
        return require("private-next-pages/components/accordion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/accordion"])
      });
    }
  